import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { LANGUAGE_CODES, DEFAULT_LANGUAGE, RTL_LANGUAGES } from "./config";

import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import pt from "./locales/pt.json";
import it from "./locales/it.json";
import tr from "./locales/tr.json";
import hi from "./locales/hi.json";
import ur from "./locales/ur.json";

const resources = {
  en: { translation: en }, ar: { translation: ar }, fr: { translation: fr }, es: { translation: es },
  de: { translation: de }, pt: { translation: pt }, it: { translation: it }, tr: { translation: tr },
  hi: { translation: hi }, ur: { translation: ur },
};

export function applyDocumentLanguage(lng) {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "adwiz_language",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

applyDocumentLanguage(i18n.resolvedLanguage || DEFAULT_LANGUAGE);
i18n.on("languageChanged", (lng) => applyDocumentLanguage(lng.split("-")[0]));

export default i18n;
